module.exports = __webpack_public_path__ + "img/14.879c625d.jpg";